import { Box, Divider, Typography } from '@fullstory/components';
import { allSpecObjectsBySlug, pagesSelectors } from '@fullstory/redux';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { PageDefinitionBody } from '../PageDefinition';
import { PillText } from '@fullstory/library-ui';
import { getPageName } from '@fullstory/pages-shared/utils/utils';

const { pagesByIdWithPageDefZero } = pagesSelectors;

export type SpecPageBodyProps = {
  slug: string;
};

export const SpecPageBody: React.VFC<SpecPageBodyProps> = ({ slug }) => {
  const pageDefinitions = useSelector(pagesByIdWithPageDefZero);
  const specPage = useSelector(allSpecObjectsBySlug)[slug];

  const pageId = specPage?.mapping?.pageId;
  if (!pageId) {
    return <></>;
  }

  const pageDefinition = pageDefinitions.get(pageId);
  if (!pageDefinition) {
    return <></>;
  }

  return (
    <div>
      {specPage?.config?.notes && (
        <Box paddingBottom={8}>
          <Box paddingBottom={8}>
            <Typography variant="body3" color="neutrals-n7">
              {specPage.config.notes}
            </Typography>
          </Box>
          <Divider />
        </Box>
      )}
      <Box marginBottom={8}>
        <Typography variant="body3">
          <FormattedMessage defaultMessage="Mapped To Page" id="MG060F" />
        </Typography>
      </Box>
      <Box marginBottom={24}>
        <PillText>{getPageName(pageDefinition)}</PillText>
      </Box>
      <PageDefinitionBody pageDefinition={pageDefinition} omitDescription />
    </div>
  );
};
